import { Component } from 'react';
import { connect } from 'react-redux';
import { dzurAktualaSituacijaSelected } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  FormGroup,
  Label,
  Col
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import FormCard from '../forms/FormCard';
import NavGeometrijaBridinajums from './NavGeometrijaBridinajums';
import Loading from '../Loading';
import { getNovertejumsColor } from './DzeramaUdensSatecesBaseinsKartina';
import { guiSet } from '../../actions/uiActions';

export const IPATSVARS = 'IPATSVARS';

export const novertejumStyleFunc = (cell) => ({ backgroundColor: getNovertejumsColor(cell) });

export const commonColumnProps = {
  align: 'center',
  headerStyle: { width: '30%' }
}

export const smallColumn = {
  ...commonColumnProps,
  headerStyle: { width: '15%' }
}

export const extraSmallColumn = {
  ...commonColumnProps,
  headerStyle: { width: '10%' }
}

export const commonColumns = [
  { ...smallColumn, dataField: 'varbutiba', text: 'Varbūtība' },
  { ...smallColumn, dataField: 'sekas', text: 'Sekas' },
  {
    ...smallColumn,
    dataField: 'novertejums',
    text: 'Novērtējums',
    style: novertejumStyleFunc
  }]
export const kategorijaColumnsCommon = [
  {
    ...smallColumn,
    dataField: 'kriterija_apraksts',
    text: 'Kritērijs',
    formatter: (cell) => cell || '-'
  },
  {
    ...smallColumn,
    dataField: 'zime',
    text: 'Kritērija vērtība',
    formatter: (cell, row) => (
      !cell ? "-" : `${cell} ${row.threshold_value ? row.kriterija_tips === IPATSVARS ? row.threshold_value * 100 : row.threshold_value : ''}`
    )
  },
  {
    ...commonColumnProps,
    dataField: 'aizsargatiba',
    text: 'Aizsargātības pakāpe',
  },
  ...commonColumns
];
export const kategorijaIpatsvarsColumns = [
  {
    ...smallColumn,
    dataField: 'apjoms',
    text: 'Īpatsvars (%)',
    formatter: (cell) => (
      !cell ? "-" : `${cell.toFixed(1)} %`
    )
  },
  ...kategorijaColumnsCommon
];
export const kategorijaColumns = [
  {
    ...smallColumn,
    dataField: 'apjoms', text: 'Objektu skaits',
    formatter: (cell) => (
      cell || '-'
    )
  },
  ...kategorijaColumnsCommon
];

export const riskaObjektiColumns = [
  { ...extraSmallColumn, dataField: 'source_identifikators', text: 'ID' },
  { ...commonColumnProps, dataField: 'nosaukums', text: 'Nosaukums' },
  { ...commonColumnProps, dataField: 'adrese', text: 'Adrese' },
  { ...smallColumn, dataField: 'min_urb_distance', text: 'Attālums līdz urbumam (m)', align: 'center', width: 80, formatter: (cell) => (cell === null ? '-' : cell.toFixed(1)), },
  ...commonColumns
];

export const modalFieldDefinitions = [
  { field: 'source_identifikators', label: 'ID' },
  { field: 'nosaukums', label: 'Nosaukums' },
  { field: 'adrese', label: 'Adrese' },
  { field: 'piezimes', label: 'Piezīmes' },
  { field: 'atjaunosanas_laiks', label: 'Atjaunots' },
  { field: 'platiba', label: 'Platība' }
];

class DzurSituacija extends Component {
  state = {
    modalOpen: false,
    modalData: null,
    expanded: {}
  };

  componentDidUpdate(prevProps) {
    const { dzur_aktuala_situacija } = this.props;
    if (dzur_aktuala_situacija?.list?.length > 0 && dzur_aktuala_situacija.selected &&
      dzur_aktuala_situacija.selected !== prevProps.dzur_aktuala_situacija?.selected) {
      const kat = dzur_aktuala_situacija.list.find(kat => kat.riska_objekti?.find(ro => ro.id === dzur_aktuala_situacija.selected))
      if (kat) {
        this.setState(prev => ({
          expanded: { ...prev.expanded, [kat.id]: true }
        }));
      }
    }
  }

  getRowClassesForRiskaObjekts = (row) => {
    const { dzur_aktuala_situacija } = this.props;
    return row.id === dzur_aktuala_situacija.selected ? 'table-primary' : '';
  }

  handleRiskaObjektsRowClick = (_e, row) => {
    this.props.dzurAktualaSituacijaSelected(row.id);
  }

  toggleModal = () => this.setState(s => ({ modalOpen: !s.modalOpen, modalData: null }));

  handleOpenModal = (object) => {
    this.setState({
      modalOpen: true,
      modalData: object
    });
  }

  renderModal() {
    const { modalOpen, modalData } = this.state;

    if (!modalData) return null;

    let parsedPapDati = {};
    if (modalData.pap_dati) {
      if (typeof modalData.pap_dati === 'object') {
        parsedPapDati = modalData.pap_dati;
      } else if (typeof modalData.pap_dati === 'string') {
        try {
          parsedPapDati = JSON.parse(modalData.pap_dati);
        } catch (_e) {
          parsedPapDati = {};
        }
      }
    }
    const parsedPapDatiFields = Object.entries(parsedPapDati).map(([key, value]) => ({
      field: value,
      label: key,
      isParsedPapDati: true
    }));
    const modalFields = [...parsedPapDatiFields, ...modalFieldDefinitions];

    return (
      <Modal isOpen={modalOpen} toggle={this.toggleModal} size="lg">
        <ModalHeader toggle={this.toggleModal}>
          {`Dati par riska objektu "${modalData.nosaukums || modalData.adrese || modalData.source_identifikators}"`}
        </ModalHeader>
        <ModalBody>
          {modalFields.map(({ field, label, isParsedPapDati }, idx) => <FormGroup row key={`${label}-${idx}`}>
            <Col xs={12} md={4} className="formlabel-col">
              <Label className="field-label">{label}</Label>
            </Col>
            <Col xs={12} md={8} className="form-col bold">
              {isParsedPapDati ? field ?? '-' : modalData[field] ?? '-'}
            </Col>
          </FormGroup>
          )}
        </ModalBody>
      </Modal>
    );
  }

  viewModalBtnColumn = {
    dataField: 'df1',
    text: '',
    isDummyField: true,
    formatter: (_cellContent, row) => {
      return (
        <Button
          color="secondary"
          size="sm"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.handleOpenModal(row);
          }}
        >
          <i className="fa fa-file-text-o"></i>
        </Button>
      );
    },
    classes: 'td-button',
    headerStyle: { width: 36 }
  };

  renderKategorijaTable = (kategorija) => {
    const { id, nosaukums_display, kriterija_tips, riska_objekti } = kategorija;
    const hasObjekti = riska_objekti?.length > 0;
    return (
      <div key={id}>
        <h5>{nosaukums_display}</h5>
        <BootstrapTable
          keyField="id"
          data={[kategorija]}
          columns={kriterija_tips === IPATSVARS ? kategorijaIpatsvarsColumns : kategorijaColumns}
          bootstrap4
          striped
          hover
          condensed
          rowEvents={{
            onClick: (_e, row) => {
              this.setState(prev => ({
                expanded: {
                  ...prev.expanded,
                  [row.id]: !prev.expanded[row.id]
                }
              }));
            }
          }}
          expandRow={hasObjekti ? {
            renderer: (row) => {
              if (!row.riska_objekti || row.riska_objekti.length === 0) {
                return null;
              }
              return (
                <BootstrapTable
                  keyField="id"
                  data={row.riska_objekti}
                  columns={[this.viewModalBtnColumn, ...riskaObjektiColumns]}
                  bootstrap4
                  striped
                  hover
                  condensed
                  rowEvents={{
                    onClick: this.handleRiskaObjektsRowClick
                  }}
                  rowClasses={this.getRowClassesForRiskaObjekts}
                />
              );
            },
            expanded: (this.state.expanded?.[id]) ? [id] : [],
            showExpandColumn: false,
            expandByColumnOnly: false,
          } : undefined}
        />
      </div>
    );
  };

  render() {
    const { dzur_aktuala_situacija, hasGeometry } = this.props;
    const { list, loading } = dzur_aktuala_situacija

    if (!list || loading) {
      return <Loading />;
    }

    if (!hasGeometry) {
      return <NavGeometrijaBridinajums title="Aktuālā situācija" />;
    }

    return (
      <><div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
        {list.map((x, i, arr) =>
          i === 0 || x.riska_kategorija_grupa !== arr[i - 1].riska_kategorija_grupa ? (
            <FormCard key={x.riska_kategorija_grupa} title={x.riska_kategorija_grupa} size={12}>
              {arr.slice(i).filter(y => y.riska_kategorija_grupa === x.riska_kategorija_grupa)
                .map(y => this.renderKategorijaTable(y))}
            </FormCard>
          ) : null
        )}
      </div>
        <div style={{ padding: "5px" }}><i>Informācija par riska objektiem tiek atjaunota reizi stundā.</i></div >
        {this.renderModal()}
      </>
    );
  }
}

const mapStateToProps = ({ dzur_aktuala_situacija, gui }) => ({ dzur_aktuala_situacija, gui });

export default connect(mapStateToProps, {
  guiSet, dzurAktualaSituacijaSelected
})(DzurSituacija);
